import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as styles from './BankList.css';
import { IBank } from '../../types/promosPage';
import { BankItem } from '../BankItem';
import { RoundArrowLeft } from '../RoundArrowLeft';
import { RoundArrowRight } from '../RoundArrowRight';
import { VerticalSlider } from '../VerticalSlider';

interface IBankListProps {
  banks: IBank[];
  onCardView(position: number, bank: IBank): void;
  onCardClick(position: number, bank: IBank): void;
}

export const BankList: React.FC<IBankListProps> = ({ banks, onCardView, onCardClick }) => {
  return (
    <div className={styles['container']}>
      <VerticalSlider leftArrow={RoundArrowLeft} rightArrow={RoundArrowRight}>
        {banks.map((bank, index) => {
          const position = index + 1;

          return (
            <ActionAfterViewObserver key={bank.url} triggerOnce={true} callback={() => onCardView(position, bank)}>
              <div className={styles['slide']}>
                <BankItem
                  title={bank.title}
                  url={bank.url}
                  logo={bank.logo}
                  onClick={() => onCardClick(position, bank)}
                />
              </div>
            </ActionAfterViewObserver>
          );
        })}
      </VerticalSlider>
    </div>
  );
};
